import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { WorkRecord, WorkRecordParams } from './types';

export const GET_WORK_RECORD_LIST = 'workRecords/GET_WORK_RECORD_LIST';
export const GET_WORK_RECORD_LIST_SUCCESS =
  'workRecords/GET_WORK_RECORD_LIST_SUCCESS';
export const GET_WORK_RECORD_LIST_ERROR =
  'workRecords/GET_WORK_RECORD_LIST_ERROR';

export const CREATE_WORK_RECORD = 'workRecords/CREATE_WORK_RECORD';
export const CREATE_WORK_RECORD_SUCCESS =
  'workRecords/CREATE_WORK_RECORD_SUCCESS';
export const CREATE_WORK_RECORD_ERROR = 'workRecords/CREATE_WORK_RECORD_ERROR';

export const UPDATE_WORK_RECORD = 'workRecords/UPDATE_WORK_RECORD';
export const UPDATE_WORK_RECORD_SUCCESS =
  'workRecords/UPDATE_WORK_RECORD_SUCCESS';
export const UPDATE_WORK_RECORD_ERROR = 'workRecords/UPDATE_WORK_RECORD_ERROR';

export const DELETE_WORK_RECORD = 'workRecords/DELETE_WORK_RECORD';
export const DELETE_WORK_RECORD_SUCCESS =
  'workRecords/DELETE_WORK_RECORD_SUCCESS';
export const DELETE_WORK_RECORD_ERROR = 'workRecords/DELETE_WORK_RECORD_ERROR';

export const GET_WORK_RECORD_DETAIL = 'workRecords/GET_WORK_RECORD_DETAIL';
export const GET_WORK_RECORD_DETAIL_SUCCESS =
  'workRecords/GET_WORK_RECORD_DETAIL_SUCCESS';
export const GET_WORK_RECORD_DETAIL_ERROR =
  'workRecords/GET_WORK_RECORD_DETAIL_ERROR';

export const getWorkRecordListAsync = createAsyncAction(
  GET_WORK_RECORD_LIST,
  GET_WORK_RECORD_LIST_SUCCESS,
  GET_WORK_RECORD_LIST_ERROR,
)<WorkRecordParams, WorkRecord[], AxiosError>();

export const createWorkRecordAsync = createAsyncAction(
  CREATE_WORK_RECORD,
  CREATE_WORK_RECORD_SUCCESS,
  CREATE_WORK_RECORD_ERROR,
)<WorkRecordParams, WorkRecord, AxiosError>();

export const updateWorkRecordAsync = createAsyncAction(
  UPDATE_WORK_RECORD,
  UPDATE_WORK_RECORD_SUCCESS,
  UPDATE_WORK_RECORD_ERROR,
)<WorkRecordParams, WorkRecord, AxiosError>();

export const deleteWorkRecordAsync = createAsyncAction(
  DELETE_WORK_RECORD,
  DELETE_WORK_RECORD_SUCCESS,
  DELETE_WORK_RECORD_ERROR,
)<WorkRecordParams, number, AxiosError>();

export const getWorkRecordDetailAsync = createAsyncAction(
  GET_WORK_RECORD_DETAIL,
  GET_WORK_RECORD_DETAIL_SUCCESS,
  GET_WORK_RECORD_DETAIL_ERROR,
)<WorkRecordParams, WorkRecord, AxiosError>();
